


import { toast } from "sonner";
import api from "../../apiclient/api";
import { showServerError } from "../helpers/commonhelper";

// countries api 
export const getCountries = async () => {
    try {
        const response = await api.get('/Country');
        return response.data.data;
    } catch (error) {
        // toast.error("Error Fetching Countries")
        showServerError()
        return
    }
};

// states api
export const getStates = async (countryId) => {
    try {
        const response = await api.get(`country/states/${countryId}`);
        return response.data.data;
    } catch (error) {
        // toast.error(`Error Fetching Countries`)
        showServerError()
        return
    }
};

// cities api
export const getCities = async (stateId) => {
    try {
        const response = await api.get(`Country/city/${stateId}`);
        return response.data.data;
    } catch (error) {
        // toast.error(`Error fetching cities for city ${stateId}`)
        showServerError()
        return
    }
};

// register user api
export const registerUser = async (userData) => {
    try {
        const response = await api.post('auth/register', userData);
        return response.data;
    } catch (error) {
        toast.error("Error Registering User")
        return
    }
};

// getALlStates api
export const getAllStates = async () => {
    try {
        const response = await api.get(`country/AllStates`);
        return response.data.data;
    } catch (error) {
        // toast.error(`Error Fetching Countries`)
        showServerError()
        return
    }
};

// getallcities api
export const getAllCities = async (stateId) => {
    try {
        const response = await api.get(`country/AllCity`);
        return response.data.data;
    } catch (error) {
        // toast.error(`Error fetching cities for city ${stateId}`)
        showServerError()
        return
    }
};
